module.exports = __webpack_public_path__ + "static/media/mask4.048718f0.JPG";